import axios from "axios";
import { authHeader } from "./auth-header";

const getAll = (keyword, page, perPage, all, active) => {
  return axios.get(process.env.REACT_APP_API_URL + "reviews/list", {
    headers: authHeader(),
    data: {},
    params: {
      keyword,
      page,
      perPage,
      all,
      active
    },
  });
};

const get = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `review/view/${id}`, {
    headers: authHeader(),
  });
};

const updateStatus = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `review/updateStatus/${id}`, data,
    {
      headers: authHeader(),
    }
  );
};

const deleteReview = (id, data) => {
  return axios.delete(process.env.REACT_APP_API_URL + `review/delete/${id}`, {
    headers: authHeader(),
    data,
  });
};

const restore = (id, data) => {
  return axios.get(process.env.REACT_APP_API_URL + `review/restore/${id}`, {
    headers: authHeader(),
    params: data,
  });
};

const update = (id, data) => {
  return axios.put(process.env.REACT_APP_API_URL + `review/update/${id}`, data, {
    headers: authHeader(),
  });
};

const create = (data) => {
  return axios.post(process.env.REACT_APP_API_URL + "review/create", data, {
    headers: authHeader(),
  });
};

export default {
  getAll,
  get,
  updateStatus,
  deleteReview,
  restore,
  update,
  create
};